import * as Styles from './AvailableInvestmentsStyles'
import { Spacer, Row } from '../../../../components'
import AvailableInvestment from './AvailableInvestment'
import { withRouterProps } from '../../../../utils'

const AvailableInvestments = ({ availableInvestments, displayTitle, toggleAdd }) => {
  return (
    <Styles.InvestmentsContainer>
      {displayTitle && 'Other available investment options'}
      <Spacer space='5px' />
      {availableInvestments.map(investment => (
        <Row
          style={{ width: '100%', flexWrap: 'nowrap', marginBottom: '10px' }}
          key={investment.id}>
          <AvailableInvestment investment={investment} toggleAdd={toggleAdd} />
        </Row>
      ))}
    </Styles.InvestmentsContainer>
  )
}

export default withRouterProps(AvailableInvestments)
